import useGlobalState from '@components/Hooks/useGlobalState';
import Success from '@Shared/Success';
import React from 'react';

const GetStartedSuccess: React.FC = () => {

  const [store,] = useGlobalState();

  return (store.requested && !store.requested.message) ? (
    <Success>
      <p>Administrators have been notified of your request and should be contacting you shortly.</p>
    </Success>
  ) : null;
}

export default GetStartedSuccess;